import axios from 'services/http';
import { CancelTokenSource } from 'axios';
import { DayStatisticRequest, DayStatisticResponse, PdfResponse } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/day-statistic`;

export const getTurnOverOrPendingDayStatistic = (
    request: DayStatisticRequest,
    source: CancelTokenSource): Promise<DayStatisticResponse> => {
  return axios
      .post(`${apiUri}/turn-over-or-pending`, request, {cancelToken: source.token})
      .then((response) => response.data);
};

export const getProceduresProtocolPrintOutput = (request: Partial<DayStatisticRequest>,
                                                 source: CancelTokenSource): Promise<PdfResponse> => {
  return axios
      .post(`${apiUri}/output`, request, {cancelToken: source.token})
      .then(response => response.data)
};

export const getProceduresProtocolPdfUrl = (proceduresProtocolPdfId: string, proceduresProtocolPdfName: string) => {
  return `${baseUrl}/41fe87120ce3497397ad98f4919e93ee/${proceduresProtocolPdfId}/${proceduresProtocolPdfName}`;
};
